import $ from 'jquery';
import './kfits/kfits.js';
import './ktabs/ktabs.js';
import './pagetitle/pagetitle.js';
import './ktable/ktable.js';
import './prevnextauswahl/prevnextauswahl.js';
import './spieltagsauswahl/spieltagsauswahl.js';
window.jQuery = window.$ = $
